import { FormState, TextInput } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { messages } from '../../messages'

type Props = {
  form: FormState
}

const FORM_FIELD = 'name'

export function Name(props: Props) {
  const { form } = props
  const { $t } = useIntl()

  const onBlur = () => form.trigger(FORM_FIELD)

  return (
    <TextInput
      name={FORM_FIELD}
      state={form}
      width="100%"
      label={$t(messages.editor.name)}
      //@ts-expect-error Property 'onBlur' does not exist on type 'IntrinsicAttributes & InheritedProps$7 & FormFieldProps'
      onBlur={() => onBlur()}
    />
  )
}
